import React from "react";
import { useNavigate } from "react-router";

const CommonOpacityBackground = ({
  children,
  path,
  customFunction,
  className,
}) => {
  const navigate = useNavigate();
  return (
    <section
      onClick={() => {
        if (customFunction) {
          customFunction();
        } else {
          navigate(path);
        }
      }}
      className={`bg-[#171a1ce6] z-[99999] fixed top-0 left-0 w-full h-full flex items-start md:py-[46px] justify-center ${className}`}
    >
      {children}
    </section>
  );
};

export default CommonOpacityBackground;
